import * as yup from "yup";
import { exampleError } from "./reimbursementExamples";

export const planDetailsValidation = yup.object().shape({
  name: yup.string().required("Le nom est requis"),
  identifier: yup.string().required("L'identifiant est requis"),
});

export const selectCoveragesValidation = yup.object().shape({
  insurancePlanCoverages: yup
    .array()
    .min(1, "Au moins une garantie est requise"),
});

export const configureBenefitsValidation = yup.object().shape({
  insurancePlanCoverages: yup.array().of(
    yup.object().shape({
      coverageMappings: yup
        .array()
        .min(1, "Au moins une prestation est requise"),
    }),
  ),
});

export const reimbursementExamplesValidation = yup.object().shape({
  supportingInformation: yup.array().test("examples", function (rows) {
    const message = (rows || []).map(exampleError).find(Boolean);
    if (!message) return true;
    return this.createError({ message });
  }),
});

export const stepValidations = [
  planDetailsValidation,
  selectCoveragesValidation,
  configureBenefitsValidation,
  reimbursementExamplesValidation,
  null,
];
